export default {"src":"/_next/static/media/HYDT.5fe1c412.svg","height":30,"width":180,"blurWidth":0,"blurHeight":0};